import { CssBaseline } from '@mui/material';
import { useRoutes } from 'react-router-dom';
import { MatxTheme } from './components';
import { SettingsProvider } from './contexts/SettingsContext';
import routes from './routes';
import { Provider } from 'react-redux';
import store from './contexts/store';

const App = () => {
  const content = useRoutes(routes);

  return (
    <SettingsProvider>
      <Provider store={store}>
        <MatxTheme>
          <CssBaseline />
          {content}
        </MatxTheme>
      </Provider>
    </SettingsProvider>
  );
};

export default App;
